import { Fade, Typography, Stack, Paper, Chip } from '@mui/material';
import { useContext, useEffect } from 'react';
import {
  fadeTimingMs,
  BaseDetailCard,
  metricPlanCardClasses,
  getFormattedTableEntry,
  EyeIcon2,
  cropsRunNewAndDetailRoute,
} from '../../utility';
import NoEntityMsg from '../../utility/messages/NoEntityMsg';
import { useNavigate } from 'react-router';
import APIService from '../../../api/apiService';
import { FeedbackContext } from '../../../App';
import { fetchFrtlData } from '../../../api/apiUtils';
import { FRTLContext } from '../../../context/FRTLContext';

export default function _CropRunTab(props) {
  const { values, currDarkThemeClass, cropplanperms, handleErrorWithFeedback, handleSetValues } = props;
  const feedbackCX = useContext(FeedbackContext);
    const { frtlContextValue, setFrtlContextValue } = useContext(FRTLContext);
  

  const navigate = useNavigate();
  console.log(cropplanperms);

    useEffect(() => {
      if (!frtlContextValue) {
        fetchFrtlData()
          .then(data => {
            setFrtlContextValue(data || {});
          })
          .catch(error => {
            console.error('Error loading FRTL data:', error);
            setFrtlContextValue({});
          });
      }
    }, [frtlContextValue, setFrtlContextValue]);

  const handleShow = id => () => {
    // if (!cropplanperms?.update || !cropplanperms?.view) {
    //   handleErrorWithFeedback({ response: { status: 400, data: { text: 'Do Not have permissions to View/update' } } });
    //   return;
    // }
    navigate(`${cropsRunNewAndDetailRoute}/${id}/`);
  };

  const handleDelete = (id) => () => {
    if (!cropplanperms?.delete) {
      handleErrorWithFeedback({ response: { status: 400, data: { text: 'Do not have permissions to delete crop run' } } });
      return;
    }
    const entityWithID = `cropplan/${id}/`;
    APIService.deleteInstance(entityWithID)
      .then(() => {
        handleSetValues(
          'cropruns',
          values?.cropruns?.filter((plan) => plan?.id !== id)
        )
        feedbackCX.setContextValue(true, {
          type: 'success',
          message: 'Deleted crop run successfully.',
          autoHideDuration: 3000,
        }) })
      .catch((data) => {        
        handleErrorWithFeedback({ response: { status: 510, data: { text: data?.response?.data?.message ? data?.response?.data?.messag : 'Internal Server Error!'}}
        });
      });
  };

  const plansBoxProps = {
    className: `${metricPlanCardClasses.paperWrapper} ${currDarkThemeClass}`,
    variant: 'square',
    elevation: 0,
  };

  const cdSubHeaderProps = {
    direction: 'row',
    spacing: 2,
    alignItems: 'center',
  };

  const cdSubHeaderTypo = {
    className: `${metricPlanCardClasses.subHeaderTypo} ${currDarkThemeClass}`,
    variant: 'subtitle2',
  };

  const subHeader = croprun => {
  const getCombinedTargetDisplay = (batches) => {
    if (!batches || batches.length === 0) {
      return '-';
    }
    const uniqueTargets = [];
    const seenTargets = new Set();
    
    batches.forEach(batch => {
      const targetKey = `${batch.target_subphase_name}_${batch.target_subphase_date}`;
      if (!seenTargets.has(targetKey)) {
        seenTargets.add(targetKey);
        uniqueTargets.push({
          date: batch.target_subphase_date,
          subphase: batch.target_subphase_name
        });
      }
    });
    
    return uniqueTargets
      .map(target => {
        const formattedDate = getFormattedTableEntry(
          { date: target.date }, 
          { key: 'date', isDate: true }
        );
        return `${target.subphase}  (${formattedDate})`;
      })
      .join(' , ');
  };

  const getTotalPlantCount = (batches) => {
    if (!batches || batches.length === 0) {
      return 0;
    }
    return batches.reduce((sum, batch) => {
      const plantCount = getFormattedTableEntry(
        batch, 
        { key: 'plant_count', isNum: true }
      );
      return sum + (plantCount || 0);
    }, 0);
  };

  const entryTitleValueMap = [
    { 
      title: 'Target',
      key: 'combined_target',
      isCustom: true,
      value: getCombinedTargetDisplay(croprun.batches) 
    },
    {
      title: 'Plant Count', 
      key: 'total_plant_count',
      isCustom: true,
      value: getTotalPlantCount(croprun.batches) 
    },
  ];

  const entries = entryTitleValueMap.map((e, i) => (
    <Typography key={i} {...cdSubHeaderTypo}>
      {e?.title} : {e.isCustom ? e.value : getFormattedTableEntry(croprun, e)}
    </Typography>
  ));

  return <Stack {...cdSubHeaderProps}>{entries}</Stack>;
};

  const cardActionBtns = croprun => [
    {
      key: 'details',
      title: 'Show Details',
      icon: EyeIcon2,
      otherProps: {
        onClick: handleShow(croprun?.id),
      },
    },
  ];

  const cropPlanCardProps = croprun => ({
    baseEntity: croprun?.name,
    extrasTitle: <Chip label={croprun?.run_status} color="primary" variant="outlined" size="small" />,
    isHeaderClickable: true,
    headerClickHandler: handleShow(croprun?.id ?? croprun?.tempRef),
    noEntityMsg: 'Unknown Cropplan',
    cropplanperms: cropplanperms,
    currDarkThemeClass,
    subHeader: subHeader(croprun),
    cardActionBtns: cardActionBtns(croprun),
  });

  const plansCardList =
    values?.cropruns?.length > 0 ? (
      values?.cropruns?.map((e, i) => <BaseDetailCard key={i} {...cropPlanCardProps(e)} />)
    ) : (
      <NoEntityMsg entity={!cropplanperms?.create ? "Crop Run. Ask your Admin to grant you access to create Crop Run" : "Crop Run"}  isCreateEnabled={values?.qualityPlanExists && cropplanperms?.create} onCreateClick={() => cropplanperms?.create && navigate(`${cropsRunNewAndDetailRoute}/new/`)} />
    );

  return (
    <Fade in={true} timeout={fadeTimingMs}>
      <Paper {...plansBoxProps}>{plansCardList}</Paper>
    </Fade>
  );
}
